module.exports = __webpack_public_path__ + "static/media/service.1c18f733.mp4";